import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportsApi } from '../../../api/client';
import RangeBar from './components/RangeBar';
import ExportButtons from './components/ExportButtons';
import ReportTable from './components/ReportTable';
import useRangeState from './components/useRangeState';
import FiltersBar from './components/FiltersBar';
import HelpButton from '../../help/HelpButton';

function fmtSecs(n) {
  if (n == null) return '—';
  const s = Number(n) || 0;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, '0')}`;
}

export default function TrunkPerformance() {
  const [range, setRange, apiParams] = useRangeState('today');
  const [filters, setFilters] = useState({});
  const merged = { ...apiParams, ...filters };

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: ['reports', 'trunks', merged],
    queryFn: () => reportsApi.trunks(merged),
    refetchInterval: range.preset === 'today' ? 30_000 : false,
    keepPreviousData: true,
  });

  return (
    <div>
      <RangeBar value={range} onChange={setRange} />

      <div className="flex items-center justify-between mb-2">
        <h2 className="text-base font-semibold">{data?.title || 'Trunk performance'}</h2>
        <div className="flex items-center gap-2">
          <span className="text-xs text-surface-muted">{data?.subtitle}</span>
          <HelpButton moduleKey="reports" />
          <ExportButtons report="trunks" params={merged} disabled={isLoading} />
          <button
            type="button"
            onClick={() => refetch()}
            className="px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle"
          >
            ↻ {isFetching ? '…' : 'Refresh'}
          </button>
        </div>
      </div>

      {isError && (
        <div className="text-sm text-red-600 dark:text-red-300 p-3 rounded-thin border border-red-300/40 mb-3">
          {error?.detail || error?.message || 'Failed to load report.'}
        </div>
      )}

      <ReportTable
        headers={['trunk','calls','answered','no_answer','failed','avg_call_sec','asr_pct','_clusters']}
        rows={data?.rows || []}
        columnLabels={{
          trunk: 'Trunk',
          calls: 'Calls',
          answered: 'Answered',
          no_answer: 'No answer',
          failed: 'Failed',
          avg_call_sec: 'Avg call',
          asr_pct: 'ASR %',
        }}
        formatters={{
          avg_call_sec: fmtSecs,
          asr_pct: (v) => v == null ? '—' : `${v}%`,
        }}
      />
    </div>
  );
}
